export default {
  AUTH: 'auth',
  REWARD: 'reward',
  WEALTH: 'wealth',
  CENTER: 'center',
  SEARCH: 'search',
};